<template>
    <div class="row">
        <div class="col-12 my-3">
            <div class="row">
                <div class="col-lg-4 col-md-6 mb-3">
                    <div class="card shadow card-custom text-center h-100">
                        <div class="card-body d-flex flex-column justify-content-center">
                            <h5 class="card-title text-muted">{{ $t('perfil_invitaciones.total_invitaciones_temporada') }}</h5>
                            <h2 class="card-number text-success">{{ abonado.invitaciones_abonado.n_total_temporada }}</h2>
                        </div>
                    </div>
                </div>
                
                <div class="col-lg-4 col-md-6 mb-3">
                    <div class="card shadow card-custom text-center h-100">
                        <div class="card-body d-flex flex-column justify-content-center">
                            <h5 class="card-title text-muted">{{ $t('perfil_invitaciones.invitaciones_restantes') }}</h5>
                            <h2 class="card-number text-primary">{{ abonado.invitaciones_abonado.n_total_disponibles }}</h2>
                        </div>
                    </div>
                </div>
                
                <div class="col-lg-4 col-md-6 mb-3">
                    <div class="card shadow card-custom text-center h-100">
                        <div class="card-body d-flex flex-column justify-content-center">
                            <h5 class="card-title text-muted">{{ $t('perfil_invitaciones.invitaciones_consumidas') }}</h5>
                            <h2 class="card-number text-danger d-flex align-items-center justify-content-center">
                                {{ abonado.invitaciones_abonado.n_total_consumidas || 0 }}
                                <button 
                                    v-if="abonado.invitaciones_abonado.n_total_consumidas > 0"
                                    class="btn btn-link p-0 ml-1 icon-only-button"
                                    @click="showModal('invitaciones-abono-' + abonado.id)"
                                >
                                    <b-icon 
                                        icon="info-circle-fill" 
                                        class="text-danger" 
                                    />
                                </button>
                            </h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12">
            <h3>
                <b>{{ $t('perfil_invitaciones.eventos_disponibles_admin') }} </b>
            </h3>
        </div>

        <div class="col-12">
            <div v-if="eventos.length > 0" class="table-responsive">
                <table class="table table-hover text-nowrap">
                    <thead>
                        <tr>
                            <th>Evento</th>
                            <th class="text-center">Fecha</th>
                            <th class="text-center">Invitaciones disponibles</th>
                            <th class="text-center">Opciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(evento, index) in eventos">
                            <tr :key="index">
                                <td>
                                    <strong>{{ evento.name }}</strong>
                                </td>
                                <td class="text-center">
                                    {{ evento.start_event_date }}
                                </td>
                                <td class="text-center">
                                    {{ evento.invitaciones_restantes }}
                                </td>
                                <td class="text-center">
                                    <router-link
                                        v-if="!evento.all_invitaciones_consumidas"
                                        :to="{ name: 'back.abonados.generar-invitaciones', params: { abono_id: abonado.id, event_id: evento.id, sesion_id: evento.sesion_id } }"
                                        class="btn btn-primary btn-sm"
                                    >
                                        <span>{{ $t('perfil_invitaciones.generar_invitaciones') }}</span>
                                    </router-link>
                                    <button v-else to="#" class="btn btn-primary btn-sm disabled" style="cursor: not-allowed;">
                                        <span>{{ $t('perfil_invitaciones.invitaciones_agotadas') }}</span>
                                    </button>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
            <p v-else>
                No hay eventos disponibles para invitaciones.
            </p>
            <div v-if="eventos.length > 0">
                <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" first-number last-number />
            </div>
        </div>

        <ModalComponent 
            :name="'invitaciones-abono-' + abonado.id"
            :title="$t('perfil_invitaciones.invitaciones_consumidas')"
            @close="closeModal('invitaciones-abono-' + abonado.id)"
        >
            <b-table 
                v-if="invitacionesConsumidas.length > 0" 
                striped 
                hover 
                small 
                responsive
                :items="invitacionesConsumidas" 
                :fields="columnasConsumidas" 
            />
            <div v-else>
                <p class="text-center">{{ $t('perfil_invitaciones.no_invitaciones_consumidas') }}</p>
            </div>
        </ModalComponent>
    </div>
</template>
<script>
    import ModalComponent from '@/components/backend/components/ModalComponent';

    export default {
        name: 'InvitacionesComponent',
        props: {
            abonado: {
                type: [Object],
                required: false
            }
        },
        data() {
            return {
                loading: false,
                eventos: [],
                invitacionesConsumidas: [],
                columnasConsumidas: [
                    { key: "evento.name", label: "Evento" },
                    { key: "created_at", label: 'Fecha', },
                    { key: "user.name", label: "Invitado" }
                ],
                rows: 1,
                perPage: 1,
                currentPage: 1
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            }
        },
        methods: {
            getEventos() {
                try {
                    const params = {
                        abonado_id: this.abonado.id,
                    }
                    
                    this.$store.dispatch('BACK_ABONADOS_ABONO_LISTADO_INVITACIONES_EVENTOS', params).then(res => {
                        this.rows = res.data.meta.last_page;
                        this.perPage = res.data.meta.per_page > 5 ? res.data.per_page : 1;
                        this.currentPage = res.data.meta.current_page;
                        this.eventos = res.data.data;
                    })
                        .catch(error => {
                            const mensaje = error.response?.data?.message || 'Error al cargar eventos para invitaciones';
                            this.$toast.error(mensaje);
                        })
                } catch (error) {
                    this.$toast.error('Error al obtener datos');
                }
            },
            getInvitacionesConsumidas() {
                this.$store.dispatch('BACK_ABONADOS_ABONO_LISTADO_INVITACIONES_CONSUMIDAS', { abonado_id: this.abonado.id }).then(res => {
                    this.invitacionesConsumidas = res.data.data;
                })
                    .catch(error =>{
                        this.$toast.error('Error al cargar invitaciones consumidas');
                    });
            },
            showModal(name) {
                this.$modal.show(name);
            },
            closeModal(name) {
                this.$modal.hide(name);
            },
        },
        watch: {
            currentPage(){
                this.getEventos();
            }
        },
        created() {
            this.getEventos();
            this.getInvitacionesConsumidas();
        },
        components: {
            ModalComponent
        }
    }
</script>
<style scooped>
    .icon-only-button {
        padding: 0 !important;
        border: none !important;
        background: none !important;
        cursor: pointer;
    }
    .card-custom {
        border-radius: 1rem !important;
        transition: transform 0.2s ease, box-shadow 0.2s ease;
    }
    .card-custom:hover {
        transform: translateY(-5px);
        box-shadow: 0 8px 20px rgba(0,0,0,0.15);
    }
    .card-number {
        font-size: 1.2rem;
        font-weight: bold;
    }
    .card-title{
        font-size: 0.9rem;
        margin-bottom: 0.8rem;
    }

</style>